const LargeLinksInit = () => {
    const LargeLinks = document.querySelectorAll<HTMLElement>('.large-links');
    LargeLinks.forEach(largeLinksEl => {
        const largeLinkImage = new Image();
        const images: { src: string; alt: string }[] = JSON.parse(largeLinksEl.dataset.largeLinksImages as string);

        const largeLinkImageDiv = largeLinksEl.querySelector<HTMLDivElement>('.large-links-image');

        const links = largeLinksEl.querySelectorAll<HTMLAnchorElement>('.large-links-container a');

        links.forEach((link, index) => {
            const switchImage = () => {
                largeLinkImage.src = images[index].src;
                largeLinkImage.alt = images[index].alt;
                largeLinkImageDiv?.replaceChildren(largeLinkImage);
            };
            link.addEventListener('mouseover', switchImage);
            link.addEventListener('focus', switchImage);
        });
    });
};

document.addEventListener('DOMContentLoaded', LargeLinksInit);
